import { Routes } from '@angular/router';
import { adminGuard } from './guards/admin.guard';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent)
  },
  { path: '', redirectTo: 'inventory-list', pathMatch: 'full' },
  {
    // Dashboard temporariamente oculto do menu/navegação padrão (ainda acessível via URL direta).
    path: 'home',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/home-dashboard/home-dashboard.component').then(m => m.HomeDashboardComponent)
  },
  {
    path: 'inventory-list',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/inventory-list/inventory-list.component').then(m => m.InventoryListComponent)
  },
  {
    path: 'calendar-config',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/calendar-config/calendar-config.component').then(m => m.CalendarConfigComponent)
  },
  { path: 'request', redirectTo: 'inventory-list', pathMatch: 'full' },
  {
    path: 'group-management',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/group-management/group-management.component').then(m => m.GroupManagementComponent)
  },
  { path: 'users', canActivate: [authGuard, adminGuard],
    loadComponent: () => import('./pages/user-management/user-management.component').then(m => m.UserManagementComponent) },
  { path: '**', redirectTo: 'inventory-list' }
];
